module.exports = __webpack_public_path__ + "static/media/iconUsuario.cf315c1d.svg";